import { render, staticRenderFns } from "./RulebookOverviewTab.vue?vue&type=template&id=666b416d&scoped=true&"
import script from "./RulebookOverviewTab.vue?vue&type=script&lang=js&"
export * from "./RulebookOverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./RulebookOverviewTab.vue?vue&type=style&index=0&id=666b416d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b416d",
  null
  
)

export default component.exports